import { Spotlight } from "../ui/spotlight";

const CollegeFinal = () => {
  const scrollToBooking = () => {
    // console.log("Button clicked"); // Debug log
    const section = document.getElementById("service-college-section");
    // console.log("Section found:", section); // Debug log

    if (section) {
      section.scrollIntoView({ block: "start", behavior: "smooth" });
    } else {
      console.error('Section with id "booking-section" not found!');
    }
  };
  return (
    <div className="relative flex h-[40rem] w-full overflow-hidden rounded-md bg-black/[0.96] antialiased md:items-center md:justify-center">
      {/* Background with dots + gradient overlay */}
      <div
        className="pointer-events-none absolute inset-0 z-10"
        style={{
          background:
            "radial-gradient(circle at center, transparent 80%, rgba(0,0,0,0.96) 100%)",
        }}
      />

      {/* Background with dots */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: "radial-gradient(#404040 1px, transparent 1px)",
          backgroundSize: "20px 20px",
        }}
      />

      {/* Center gradient fade */}
      <div
        className="absolute inset-0 z-0"
        style={{
          background:
            "radial-gradient(ellipse at center, transparent 20%, black 70%)",
        }}
      />

      <Spotlight
        className="-top-40 left-0 md:-top-20 md:left-60"
        fill="white"
      />

      {/* This container now uses flexbox to center its children vertically and horizontally */}
      <div className="relative z-10 flex w-full max-w-7xl flex-col items-center justify-center p-4">
        <h1 className="bg-opacity-50 bg-gradient-to-b from-neutral-50 to-neutral-400 bg-clip-text text-center text-4xl font-bold text-transparent md:text-5xl">
          Want to Invite Us to Your{" "}
          <span className="bg-text-gradient bg-clip-text text-transparent">
            College{" "}
          </span>
          ?
        </h1>
        {/* The paragraph is now centered by the parent's `items-center` class */}
        <p className="mt-4 max-w-lg text-center text-base font-normal text-neutral-300">
          Select from the 4 services we provide and get your customized
          quotation ready.
        </p>

        {/* Added margin-top for better spacing */}
        <div className="mt-8">
          <button
            onClick={scrollToBooking}
            className="group relative overflow-hidden rounded-lg bg-gradient-to-r from-blue-600 to-indigo-600 px-8 py-3 font-medium text-white shadow-lg transition-all duration-300 hover:-translate-y-[-2px] hover:shadow-xl"
          >
            <div
              className="absolute -inset-[2px] rounded-lg"
              style={{
                background:
                  "conic-gradient(from 0deg, #3b82f6, #8b5cf6, #3b82f6, transparent, transparent, transparent, transparent, transparent)",
                animation: "spin 2s linear infinite",
              }}
            ></div>
            <div className="absolute inset-[2px] rounded-lg bg-gradient-to-r from-blue-600 to-indigo-600"></div>
            <span className="relative z-10 flex items-center gap-2 text-sm font-semibold">
              Get a Quotation
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CollegeFinal;
